import { AxiosResponse } from "axios";
import { UserPreferenecs } from "types";
import { axiosInterceptor } from "./axios";
import { userPreferencesApiPath } from "./constant";

// get profile data
export const getPreferencesApi = async () :Promise<AxiosResponse<UserPreferenecs>> => axiosInterceptor("get", userPreferencesApiPath);
export const setPreferencesApi = async (userPreferences: UserPreferenecs) :Promise<AxiosResponse<any,any>> => axiosInterceptor("put", userPreferencesApiPath, userPreferences);

